import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card, CardText } from 'react-md';
import { RingLoader } from 'react-spinners';
import { Redirect } from 'react-router-dom';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { fromJS } from 'immutable';
import { withSnackbar } from 'notistack';

import * as authActions from '../../Services/Auth/actions';
import * as themeActions from '../../Services/Theme/actions';
import * as systemActions from '../../Services/System/actions';
import CONFIG from '../../Config';
import { showAlerts } from '../Common/utils';
import CipresBlock from './customer/CipresBlock';
import Footer from './Footer';
import Header from './Header';

import './Login.scss';
import BasicCoogForm from './components/BasicCoog';
import GoogleCoogBlock from './components/GoogleCoogBlock';
import FacebookCoogBlock from './components/FacebookCoogBlock';
import ForcedotcomCoogBlock from './components/ForcedotcomCoogBlock';
import AzureCoogBlock from './components/AzureCoogBlock';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: '',
      password: '',
      canSubmit: false,
      app: {
        title: CONFIG.title,
        subTitle: CONFIG.subTitle,
        logoRef: CONFIG.logoRef,
        logoLink: CONFIG.logoLink,
      },
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.fetchUserInfoRequest();
    actions.fetchAuthorizationInfoRequest();
  }

  componentDidUpdate(prevProps) {
    const { auth, alerts, strings } = this.props;

    if (auth.get('ready') !== prevProps.auth.get('ready')) {
      showAlerts({ alerts, strings });
    }
  }

  handleSubmit = model => {
    const { actions } = this.props;
    const redirectTo = `${CONFIG.apiBaseUrl}/user/info`;
    actions.fetchAuthorizationLogin({ login: model.login, password: model.password, redirectTo });
  };

  disableButton = () => this.setState({ canSubmit: false });

  enableButton = () => this.setState({ canSubmit: true });

  getAuthenticationBlock = block => {
    const { strings } = this.props;
    const redirectTo = window.location.href;

    switch (block.get('name')) {
      case 'coog':
        return (
          <BasicCoogForm
            form={this.props.form}
            canSubmit={this.state.canSubmit}
            password={this.state.password}
            login={this.state.login}
            inError={this.props.auth.get('inError')}
            errorText={this.props.auth.get('errorText')}
            handleSubmitCallback={this.handleSubmit}
          />
        );
      case 'google':
        return <GoogleCoogBlock strings={strings} path={block.get('path')} redirectTo={redirectTo} />;
      case 'facebook':
        return <FacebookCoogBlock strings={strings} path={block.get('path')} redirectTo={redirectTo} />;
      case 'forcedotcom':
        return <ForcedotcomCoogBlock strings={strings} path={block.get('path')} redirectTo={redirectTo} />;
      case 'azure_ad_oauth2':
        return <AzureCoogBlock strings={strings} path={block.get('path')} redirectTo={redirectTo} />;
      case 'cipres-token':
        return (
          <CipresBlock
            key="cipres-token"
            returnToken={block.get('returnToken')}
            returnUrl={block.get('returnUrl')}
            returnLabel={block.get('returnLabel')}
          />
        );
      default:
        return null;
    }
  };

  renderForm = () => {
    const { auth, strings, form, theme } = this.props;
    const { app } = this.state;
    const info = auth.get('info') || fromJS([]);
    const blocks = [];
    info.forEach(block => blocks.push(this.getAuthenticationBlock(block)));

    return (
      <div className="coog-form-login">
        <Header theme={theme} app={app} strings={strings} />
        <Card style={{ minWidth: 320 }} className="md-block-centered">
          <CardText>{blocks}</CardText>
        </Card>
        <Footer theme={theme} app={app} strings={strings} />
      </div>
    );
  };

  renderSpinner = () => (
    <div className="md-block-centered">
      <RingLoader color="#123abc" loading={this.props.auth.get('loading')} />
    </div>
  );

  render() {
    const { auth } = this.props;
    if (auth.get('isAuthenticated')) {
      return <Redirect to="/" />;
    }
    return auth.get('loading') ? this.renderSpinner() : this.renderForm();
  }
}

Login.propTypes = {
  auth: ImmutablePropTypes.contains({
    loading: PropTypes.bool.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    errorText: PropTypes.string,
    inError: PropTypes.bool,
  }),
  location: ImmutablePropTypes.contains({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  actions: PropTypes.shape({
    login: PropTypes.func.isRequired,
    loggedIn: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    fetchUserInfoRequest: PropTypes.func.isRequired,
    fetchAuthorizationInfoRequest: PropTypes.func.isRequired,
    fetchAuthorizationLogin: PropTypes.func.isRequired,
    fetchUserLanguage: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    loginLabel: PropTypes.string,
    passwordLabel: PropTypes.string,
    submitLabel: PropTypes.string,
  }),
  strings: PropTypes.object,
  theme: PropTypes.object,
};

Login.defaultProps = {
  auth: fromJS({
    loading: true,
    isAuthenticated: false,
    inError: false,
    errorText: 'Identifiants incorrects',
  }),
  form: {
    loginLabel: "Nom d'utilisateur",
    passwordLabel: 'Mot de passe',
    submitLabel: 'Connexion',
  },
  strings: {},
  theme: {},
};

const mapStateToProps = state => ({
  auth: state.get('auth'),
  location: state.getIn(['router', 'location']),
  alerts: state.getIn(['auth', 'alerts']),
  strings: state.getIn(['auth', 'strings']),
  cipres: state.getIn(['cipres']),
  theme: state.get('theme').toJS(),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...authActions, ...themeActions, ...systemActions }, dispatch),
});

export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(Login));
